import styled from 'styled-components';
import {Eye} from "../../assets/images";

export const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  //background-color: rgba(251, 255, 251, 1);
  background-color: ${(props) => props.theme.bg.workspace};

  textarea:focus, input:focus {
    outline: none;
  }

  * {
  }
`;
export const LogoDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  //height: 103px;
  width: 329px;
  border-radius: 13px;
  //background-image: 1;
`;
export const FormDiv = styled.div`
  margin-top: 31px;
`;
export const InputDiv = styled.div`
  position: relative;
`;

export const SubmitDiv = styled.div`
  display: flex;
  justify-content: flex-end;
`;
export const AuthInput = styled.input`
  height: 56px;
  width: 329px;
  margin-top: 10px;
  padding-left: 12px;
  border-radius: 10px;
  padding-top: 14px;


  box-shadow: 0 0 7px rgba(0, 0, 0, 0.12), 0 0 0 rgba(0, 0, 0, 0.24);
`;

export const AuthLabel = styled.label`
  position: absolute;
  font-size: 12px;
  left: 12px;
  top: 17px;
  color: ${(props) => props.theme.text.mainGreen};
`;

export const ShowPassword = styled(Eye)`
  cursor: pointer;
  position: absolute;
  right: 9px;
  top: calc(50% - 4px);
`;


export const SubmitButton = styled.button`
  //font-weight: bold;
  cursor: pointer;
  margin-top: 28px;
  height: 36px;
  width: 88px;
  color: white;
  background: linear-gradient(0deg, #629361, #629361), #009688;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.24);
  border-radius: 10px;
`;

export const MessageSpan = styled.span`
  position:absolute;
  top:70px;
    left: 10px;
    color:rgba(149, 197, 157, 1);
    font-size: 12px;

`;








